<template>
  <div class="mt-2">
    <dialog-message
      v-if="error == 1"
      :error="error"
      :errorMessage="errorMsg"
      :messageType="messageType"
    ></dialog-message>

    <v-toolbar flat color="white">
      <v-toolbar-title>User Delete Request</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="800px" v-if="dasherData">
        <v-card>
          <v-card-title>
            <span class="headline">Demo Request</span>
          </v-card-title>

          <v-card-text>
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">First Name</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.deleteRequestUInfo.user.first_name||null }}</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">Last name</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.deleteRequestUInfo.user.last_name||null }}</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">Phone</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.deleteRequestUInfo.phone||null }}</p>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">Reason</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.deleteRequestUInfo.reason }}</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">Dasher Task Status</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.dasherTaskInfo?"True":"False" }}</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">Dasher Agent Involvement</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.dasherAgent?"True":"False" }}</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs8>
                <v-subheader class="text-black font-weight-bold">Dasher Team Involvement</v-subheader>
              </v-flex>
              <v-flex xs4>
                <p>{{ dasherData.dasherTeam?"True":"False" }}</p>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>
                <v-subheader class="text-black font-weight-bold">Admin comment</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-textarea
                  v-model="admin_comment"
                  auto-grow
                  box
                  color="deep-purple"
                  label="Admin comment"
                  rows="2"
                ></v-textarea>
              </v-flex>
            </v-layout>
              
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="red darken-1" flat @click="deleteItem('Deleted')">Delete</v-btn>
            <v-btn color="orange darken-1" flat @click="deleteItem('Rejected')">Reject</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.deleteRequests"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>    
        <td class="text-xs-center">{{ props.item.user.first_name }} {{ props.item.user.last_name }}</td>
        <td class="text-xs-center">{{ props.item.phone }}</td>
        <td class="text-xs-center">{{ props.item.reason }}</td>
        <td class="text-xs-center">{{ props.item.request_status }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            visibility
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import DialogMessage from "../../components/DialogMessage";
import api from "../../api/datadash";
export default {
  components: {
    DialogMessage,
  },
  data: () => ({
    error: 0,
    errorMsg: "",
    dialog: false,
    search: "",
    apiUrl: "dasher-delete-request",
    selectedItem:null,
    admin_comment:"",
    dasherData:null,
    headers: [
      { text: "ID", align: "center", value: "id" },     
      { text: "Name", align: "center", sortable: false, value: "first_name" },
      { text: "Phone", align: "center", value: "phone" },
      { text: "Reason", align: "center", sortable: false, value: "reason" },
      { text: "Request Status", align: "center", value: "request_status" },
      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
    editedItem: {
      first_name: "",
      last_name: "",
      reason: "",
      phone: "",
      request_status: "",
    },
    defaultItem: {
      first_name: "",
      last_name: "",
      reason: "",
      phone: "",
      request_status: "",
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "statusCode",
      "userImage",
      "docImage",
    ]),
    ...mapState(["auth"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Division" : "Edit Division";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    editItem(item) {
      // this.editedIndex = this.indexData.deleteRequests.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.selectedItem = item;
      this.getResponse(item);
      this.dialog = true;
    },
    async getResponse(item) {
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            `dasher-delete-request/${item.id}`
          );
          // console.log(data);
         return this.dasherData = data.data;
        } catch (e) {
          //
        }
      
      this.close();
    },

   async deleteItem(status) {
      const index = this.indexData.deleteRequests.indexOf(this.selectedItem);
      confirm("Are you sure you want to delete this dasher?") &&
        this.indexData.deleteRequests.splice(index, 1);
      // this.$store.dispatch("delete", [this.apiUrl, item.id]);
      try {
        let response = await api.storeData(this.auth.token, "dasher-delete-request-action", { id: this.selectedItem.id, request_status: status, admin_comment: this.admin_comment });
        // console.log(response);
        if(response.data.error){
          this.error = true;
          this.errorMsg = response.data.errorMsg;
          this.messageType = "error";
        }else{
          this.error = true;
          this.errorMsg = response.data.errorMsg;
          this.messageType = "success";
        }
          // console.log(response);
        //  if(response)
        } catch (e) {
          //
        }
      
      this.close();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      } else {
        this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
      }
      this.close();
    },
  },
};
</script>
